import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-my-plan-connect",
    prompt: 'You have MyPlanConnect enabled. Please choose your health plan carrier(s) that you would like to integrate. For more information about MyPlanConnect, click the ? icon on the right-hand side of this panel.',
    openAction: { 
        text: "Where to set up MyPlanConnect?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "My Plan Connect"
    },
    completeAction: {
    }
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-my-plan-connect.js